// Évaluateur SÛR des expressions `visible_if` / `availableWhen` / `forcedWhen`
// du schéma (ex. "has_coach === true", "outils_avant === 'autre_app_cycle' || outils_avant === 'app_perf'").
//
// Pas de eval() : on parse un mini-DSL (clauses `IDENT OP VALEUR` reliées par && / ||).
// OP ∈ {===, !==}. VALEUR ∈ {true, false, nombre, 'chaîne'}.

function parseValue(token) {
  const t = token.trim();
  if (t === 'true') return true;
  if (t === 'false') return false;
  if (t === 'null') return null;
  if (/^-?\d+(\.\d+)?$/.test(t)) return Number(t);
  const m = t.match(/^'([^']*)'$/) || t.match(/^"([^"]*)"$/);
  if (m) return m[1];
  throw new Error(`visible_if: littéral non supporté « ${token} »`);
}

function evalClause(clause, answers) {
  const m = clause.trim().match(/^([a-zA-Z_][a-zA-Z0-9_]*)\s*(===|!==)\s*(.+)$/);
  if (!m) throw new Error(`visible_if: clause invalide « ${clause} »`);
  const [, ident, op, rawValue] = m;
  const left = answers[ident];
  const right = parseValue(rawValue);
  return op === '===' ? left === right : left !== right;
}

// Évalue une expression avec la précédence usuelle && avant ||.
export function evalCondition(expr, answers) {
  if (!expr) return true;
  return expr
    .split('||')
    .some((orPart) => orPart.split('&&').every((andPart) => evalClause(andPart, answers)));
}
